export const API_VERSION = "v1";
export const API_BASE_PATH = `/api`;

export const ROUTES = {
  AUTH: {
    MOCK_LOGIN: `${API_BASE_PATH}/auth/mock-login`,
  },
  HEALTH: `${API_BASE_PATH}/health`,
  ANALYSES: {
    CREATE: `${API_BASE_PATH}/analyses`,
    GET: (id: string) => `${API_BASE_PATH}/analyses/${id}`,
    LIST: `${API_BASE_PATH}/analyses`,
  },
  LISTING_DRAFTS: {
    CREATE: `${API_BASE_PATH}/listing-drafts`,
    GET: (id: string) => `${API_BASE_PATH}/listing-drafts/${id}`,
    UPDATE: (id: string) => `${API_BASE_PATH}/listing-drafts/${id}`,
    LIST: `${API_BASE_PATH}/listing-drafts`,
  },
  ASSETS: {
    UPLOAD: `${API_BASE_PATH}/assets/upload-placeholder`,
  },
} as const;

export const MOCKUP_TEMPLATES = [
  // T-Shirt variants
  {
    id: "tshirt_white" as const,
    label: "T-Shirt Beyaz",
    category: "tshirt" as const,
    bgColor: "#ffffff",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 200, width: 400, height: 400 },
  },
  {
    id: "tshirt_black" as const,
    label: "T-Shirt Siyah",
    category: "tshirt" as const,
    bgColor: "#1a1a1a",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 200, width: 400, height: 400 },
  },
  {
    id: "tshirt_gray" as const,
    label: "T-Shirt Gri",
    category: "tshirt" as const,
    bgColor: "#808080",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 200, width: 400, height: 400 },
  },
  {
    id: "tshirt_navy" as const,
    label: "T-Shirt Lacivert",
    category: "tshirt" as const,
    bgColor: "#1b2a4a",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 200, width: 400, height: 400 },
  },
  // Hoodie
  {
    id: "hoodie_white" as const,
    label: "Hoodie Beyaz",
    category: "hoodie" as const,
    bgColor: "#f5f5f5",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 250, width: 400, height: 350 },
  },
  {
    id: "hoodie_black" as const,
    label: "Hoodie Siyah",
    category: "hoodie" as const,
    bgColor: "#1a1a1a",
    canvasWidth: 800,
    canvasHeight: 1000,
    designArea: { x: 200, y: 250, width: 400, height: 350 },
  },
  // Kupa
  {
    id: "mug_white" as const,
    label: "Kupa Beyaz",
    category: "mug" as const,
    bgColor: "#ffffff",
    canvasWidth: 800,
    canvasHeight: 600,
    designArea: { x: 200, y: 100, width: 400, height: 350 },
  },
  {
    id: "mug_black" as const,
    label: "Kupa Siyah",
    category: "mug" as const,
    bgColor: "#1a1a1a",
    canvasWidth: 800,
    canvasHeight: 600,
    designArea: { x: 200, y: 100, width: 400, height: 350 },
  },
  // Tote Bag
  {
    id: "tote_natural" as const,
    label: "Tote Bag Natural",
    category: "tote" as const,
    bgColor: "#e8dcc8",
    canvasWidth: 700,
    canvasHeight: 900,
    designArea: { x: 150, y: 200, width: 400, height: 400 },
  },
  {
    id: "tote_black" as const,
    label: "Tote Bag Siyah",
    category: "tote" as const,
    bgColor: "#1a1a1a",
    canvasWidth: 700,
    canvasHeight: 900,
    designArea: { x: 150, y: 200, width: 400, height: 400 },
  },
  // Poster
  {
    id: "poster_white" as const,
    label: "Poster Beyaz",
    category: "poster" as const,
    bgColor: "#ffffff",
    canvasWidth: 600,
    canvasHeight: 900,
    designArea: { x: 50, y: 50, width: 500, height: 800 },
  },
  // Phone Case
  {
    id: "phonecase_clear" as const,
    label: "Telefon Kilifi",
    category: "phonecase" as const,
    bgColor: "#f0f0f0",
    canvasWidth: 400,
    canvasHeight: 800,
    designArea: { x: 50, y: 100, width: 300, height: 500 },
  },
] as const;

export type MockupTemplateId = (typeof MOCKUP_TEMPLATES)[number]["id"];
export type MockupCategory = (typeof MOCKUP_TEMPLATES)[number]["category"];

export const MOCKUP_GROUPS = [
  {
    id: "all_tshirts",
    label: "Tum T-Shirtler",
    icon: "shirt",
    templateIds: ["tshirt_white", "tshirt_black", "tshirt_gray", "tshirt_navy"],
  },
  {
    id: "all_hoodies",
    label: "Tum Hoodieler",
    icon: "shirt",
    templateIds: ["hoodie_white", "hoodie_black"],
  },
  {
    id: "all_mugs",
    label: "Tum Kupalar",
    icon: "coffee",
    templateIds: ["mug_white", "mug_black"],
  },
  {
    id: "bestseller_pack",
    label: "En Cok Satan Paket",
    icon: "star",
    templateIds: ["tshirt_white", "tshirt_black", "hoodie_black", "mug_white", "tote_natural"],
  },
  {
    id: "full_collection",
    label: "Tam Koleksiyon",
    icon: "grid",
    templateIds: ["tshirt_white", "tshirt_black", "tshirt_gray", "tshirt_navy", "hoodie_white", "hoodie_black", "mug_white", "mug_black", "tote_natural", "tote_black", "poster_white", "phonecase_clear"],
  },
] as const;

export const RISK_TYPE_LABELS: Record<string, string> = {
  trademark_risk: "Marka Hakkı Riski",
  too_generic_title: "Çok Genel Başlık",
  direct_copy_composition: "Doğrudan Kopya Uyarısı",
  overused_phrase: "Çok Kullanılan İfade",
};

export const RISK_SEVERITY_COLORS: Record<string, string> = {
  low: "yellow",
  medium: "orange",
  high: "red",
};

export const MAX_TAGS = 13;
export const MAX_TITLE_LENGTH = 140;
export const MAX_DESCRIPTION_LENGTH = 10000;

/** Gorsel Kutuphanesi gruplari (ListingAsset.kind). Grup verilmezse AI gorsele bakip secer. */
export const LISTING_ASSET_KINDS = {
  font_chart: "Font tablosu",
  letter_chart: "Harf / alfabe",
  birthstone_chart: "Doğum taşı",
  birth_flower_chart: "Doğum çiçeği",
  color_chart: "Renk kartelası",
  size_chart: "Ölçü / uzunluk",
  order_guide: "Sipariş rehberi",
  care_gift: "Bakım ve hediye",
  other: "Diğer",
} as const;
export type ListingAssetKind = keyof typeof LISTING_ASSET_KINDS;

/** Liste Denetimi metin duzeltme (marka/urun uyarlamasinda baslik yeniden kurma) modelleri.
 *  Ucuzdan pahaliya; kullanici (2026-10-15): pahali model kullanilmasin. gpt-5-nano/5-mini
 *  denendi: 20-60 sn, bos/kirli cikti — listede yok. */
export const SEO_FIX_MODELS = [
  { id: "openai/gpt-5.4-nano", label: "GPT-5.4 nano" },
  { id: "openai/gpt-5.4-mini", label: "GPT-5.4 mini" },
  { id: "google/gemini-3.1-flash-lite-preview", label: "Gemini 3.1 Flash Lite" },
] as const;
export const DEFAULT_SEO_FIX_MODEL = "openai/gpt-5.4-nano";

/** "AI ile kur" urun tespiti (kutu koordinati + giysi analizi, gorselli). Gemini kutu
 *  koordinatlarinda en tutarli aile; Flash kalabalik renk tablosunda yanilabiliyor. */
export const MOCKUP_DETECT_MODELS = [
  { id: "google/gemini-3.1-pro-preview", label: "Gemini 3.1 Pro (en iyi)" },
  { id: "google/gemini-3-flash-preview", label: "Gemini 3 Flash (hızlı)" },
  { id: "openai/gpt-5.5", label: "GPT-5.5" },
] as const;
export const DEFAULT_MOCKUP_DETECT_MODEL = "google/gemini-3.1-pro-preview";

/** Nis genisletme (fikir uretimi, gorselli): cagri basina maliyet OpenRouter 2026-10-20 */
export const NICHE_IDEA_MODELS = [
  { id: "anthropic/claude-opus-5.5", label: "Claude Opus 5.5 (en iyi, ~$0.07)" },
  { id: "anthropic/claude-sonnet-5.5", label: "Claude Sonnet 5.5 (~$0.03)" },
  { id: "google/gemini-3.1-pro-preview", label: "Gemini 3.1 Pro (~$0.04)" },
  { id: "google/gemini-3-flash-preview", label: "Gemini 3 Flash (ucuz, ~$0.01)" },
] as const;
export const DEFAULT_NICHE_IDEA_MODEL = "anthropic/claude-opus-5.5";

/** Claude modelleri: Claude API kimligi, OpenRouter kimligi, ad, USD / 1M token (girdi, cikti).
 *  Kaynak: OpenRouter model listesi 2026-10-27. Fiyat tablosu, liste analizi ve eklentinin yanit
 *  model secicisi buradan beslenir; yeni model cikinca yalniz burasi guncellenir. */
export const CLAUDE_MODELS: ReadonlyArray<{ api: string; openrouter: string; name: string; price: readonly [number, number] }> = [
  { api: "claude-fable-5-1", openrouter: "anthropic/claude-fable-5.1", name: "Fable 5.1", price: [10, 50] },
  { api: "claude-opus-5-5", openrouter: "anthropic/claude-opus-5.5", name: "Opus 5.5", price: [4, 20] },
  { api: "claude-sonnet-5-5", openrouter: "anthropic/claude-sonnet-5.5", name: "Sonnet 5.5", price: [2, 10] },
  { api: "claude-haiku-5-5", openrouter: "anthropic/claude-haiku-5.5", name: "Haiku 5.5", price: [0.1, 0.5] },
  { api: "claude-fable-5", openrouter: "anthropic/claude-fable-5", name: "Fable 5", price: [10, 50] },
  { api: "claude-opus-5", openrouter: "anthropic/claude-opus-5", name: "Opus 5", price: [5, 25] },
  { api: "claude-sonnet-5", openrouter: "anthropic/claude-sonnet-5", name: "Sonnet 5", price: [2, 10] },
  { api: "claude-opus-4-8", openrouter: "anthropic/claude-opus-4.8", name: "Opus 4.8", price: [5, 25] },
  { api: "claude-opus-4-7", openrouter: "anthropic/claude-opus-4.7", name: "Opus 4.7", price: [5, 25] },
  { api: "claude-opus-4-6", openrouter: "anthropic/claude-opus-4.6", name: "Opus 4.6", price: [5, 25] },
  { api: "claude-sonnet-4-6", openrouter: "anthropic/claude-sonnet-4.6", name: "Sonnet 4.6", price: [3, 15] },
  { api: "claude-opus-4-5", openrouter: "anthropic/claude-opus-4.5", name: "Opus 4.5", price: [5, 25] },
  { api: "claude-sonnet-4-5", openrouter: "anthropic/claude-sonnet-4.5", name: "Sonnet 4.5", price: [3, 15] },
  { api: "claude-haiku-4-5", openrouter: "anthropic/claude-haiku-4.5", name: "Haiku 4.5", price: [1, 5] },
  { api: "claude-opus-4-1", openrouter: "anthropic/claude-opus-4.1", name: "Opus 4.1", price: [15, 75] },
];
